import React, {useEffect, useState} from "react";
import {useToasts} from "react-toast-notifications";
import axios from "axios";
import conf from "../../conf";
import { Button, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { FormControl } from "@material-ui/core";


const NewLottery = ()=> {

     const {addToast} = useToasts();
     const showToast = msg => addToast(msg, { appearance: 'error', autoDismiss: true });

     const date = new Date();
     const todaydate = date.getDate() + "/" + (date.getMonth()+1) + "/" + date.getFullYear();
     const [data , setData] = useState({
          draw: "81th",
          series: 5,
          prices: 30,
          endDate: todaydate,
          endTime: "12 PM",
          type: 'Evening',
          timex: '12:00',
          time: "12 PM",
          resultDate: new Date(),
     });

     const TIMES = [
          {
               name: "12 PM",
               value: "12:00",
          },
          {
               name: "12:30 PM",
               value: "12:30",
          },
          {
               name: "1 PM",
               value: "13:00",
          },
          {
               name: "1:30 PM",
               value: "13:30",
          },
          {
               name: "2 PM",
               value: "14:00",
          },
          {
               name: "2:30 PM",
               value: "14:30",
          },
          {
               name: "3 PM",
               value: "15:00",
          },
          {
               name: "3:30 PM",
               value: "15:30",
          },
          {
               name: "4 PM",
               value: "16:00",
          },
          {
               name: "4:30 PM",
               value: "16:30",
          },
          {
               name: "5 PM",
               value: "17:00",
          },
          {
               name: "5:30 PM",
               value: "17:30",
          },
          {
               name: "6 PM",
               value: "18:00",
          },
          {
               name: "6:30 PM",
               value: "18:30",
          },
          {
               name: "7 PM",
               value: "19:00",
          },
          {
               name: "7:30 PM",
               value: "19:30",
          },
          {
               name: "8 PM",
               value: "20:00",
          },
          {
               name: "8:30 PM",
               value: "20:30",
          },
          {
               name: "9 PM",
               value: "21:00",
          },
          {
               name: "9:30 PM",
               value: "21:30",
          },
          {
               name: "10 PM",
               value: "22:00",
          },
          {
               name: "10:30 PM",
               value: "22:30",
          },
          {
               name: "11:00 PM",
               value: "23:00",
          },
     ];

     useEffect(()=> {
          try {
               let [dy, mo, yr] = data.endDate.trim().split("/");
               if(`${dy}`.length < 2) dy = "0" + dy;
               if(`${mo}`.length < 2) mo = "0" + mo;
               setData({
                    ...data,
                    resultDate: new Date(`${yr}-${mo}-${dy}T${data.timex}:00Z`)
               })
          } catch (error) {
               setData({
                    ...data,
                    resultDate: "Error: " + error.message,
               })
          }
          
     }, [data.endDate, data.timex]);

     const onFormChange = (event) => {
          const value = event.target.value;
          const name = event.target.name;
          setData((prvObj)=>{
               return {
                    ...prvObj,
                    time: name === "timex" ? TIMES[event.target.selectedIndex].name : data.time,
                    [name]: value
               };
          });
     }

     const onResultTimeSelect = i => {
          setData((prvObj)=>{
               return {
                    ...prvObj,
                    time: TIMES[i].name,
                    "timex" : TIMES[i].value,
               };
          });
     }

     const onSave = async () => {

          const fromData = new FormData();
          
          for(let variable in data){
               fromData.append(variable, data[variable]);
          }
          
          try {
               await axios({
                    method: 'post',
                    url: conf.serverAddress + "admin/lottery",
                    headers: {
                         "Content-Type": "Application/json",
                         "Authorization" : `Bearer ${document.cookie.split("=")[1]}`
                    }, 
                    data: data
               });
               window.history.back();
          } 
          catch (err) {
               showToast("Failed to save.")
          }
     }

     const isFromValid = ()=>{
          if(!data.series){
               showToast("Please enter lottery series");
               return false;
          }
          else if(!data.prices){
               showToast("Please enter lottery prices");
               return false;
          }
          else if(!data.endDate.trim()){
               showToast("Please enter winning date");
               return false;
          }
          else if(!data.type.trim()){
               showToast("Please enter lottery type");
               return false;
          }
          else if(!data.timex.trim()){
               showToast("Please enter result time");
               return false;
          }
          return true;
     }

     const onAddWinnner = ()=>{
          if(isFromValid()){
               onSave();
          }
     }

     return(
          <div className="container">
               <div className="row justify-content-center">
                    <div className="col-5 grid-margin">
                         <div className="card">
                              <div className="card-body">


                                   
                              <TextField value={data.draw} onChange={onFormChange} name="draw" label="Draw" variant="outlined" style={{width: '100%'}} />
                              <TextField value={data.series} onChange={onFormChange} name="series" label="Series" variant="outlined" style={{marginTop: "20px", width: '100%'}} />
                              <TextField value={data.prices} onChange={onFormChange} name="prices" label="Lottery prices" variant="outlined" style={{marginTop: "20px", width: '100%'}} />
                              <TextField value={data.endDate} onChange={onFormChange} name="endDate" label="Result date" variant="outlined" style={{marginTop: "20px", width: '100%'}} />


                              <FormControl fullWidth style={{marginTop: '10px'}}>
                                        <InputLabel id="demo-simple-select-label">Result time</InputLabel>
                                        <Select
                                             labelId="demo-simple-select-label"
                                             id="demo-simple-select"
                                             value={data.timex}
                                             label="Result time"
                                             name="timex"
                                             >
                                                  { TIMES.map((val, i)=> <MenuItem onClick={()=>onResultTimeSelect(i)} value={val.value}>{val.name}</MenuItem>)}
                                        </Select>
                                   </FormControl>

                                   <FormControl fullWidth style={{marginTop: '10px'}}>
                                        <InputLabel id="demo-simple-select-label2">Type</InputLabel>
                                        <Select
                                             labelId="demo-simple-select-label2"
                                             id="demo-simple-select2"
                                             value={data.type}
                                             label="Type"
                                             name="type"
                                             onChange={onFormChange}
                                             >
                                                  <MenuItem value="Evening">Evening</MenuItem>
                                                  <MenuItem value="Day">Day</MenuItem>
                                                  <MenuItem value="Morning">Morning</MenuItem>
                                                  <MenuItem value="Bumper">Bumper</MenuItem>
                                        </Select>
                                   </FormControl>

                                   
                                   <Button onClick={onAddWinnner}  variant="contained" fullWidth style={{marginTop: '20px'}}>Next</Button>


                                   {/* <div onChange={onFormChange}>
                                        Draw
                                        <input type="text" value={data.draw} name="draw" style={{margin: "10px 92px", border: '1px solid black'}}/>
                                   </div>
                                   <div onChange={onFormChange}>
                                        Series
                                        <input type="number" value={data.series} name="series" style={{margin: "10px 85px", border: '1px solid black'}}/>
                                   </div>
                                   <div onChange={onFormChange}>
                                        Lottery prices
                                        <input type="number" value={data.prices} name="prices" style={{margin: "10px 30px", border: '1px solid black'}} />
                                   </div>
                                   <div onChange={onFormChange}>
                                        Result date
                                        <input type="text" name="endDate"  value={data.endDate} style={{margin: "10px 50px", border: '1px solid black'}} />
                                   </div>
                                   <div>
                                        Result time
                                        <select value={data.timex} name='timex' onChange={onFormChange} style={{margin: "10px 50px"}}>   
                                             { TIMES.map((val)=> <option value={val.value}>{val.name}</option>)}
                                        </select>
                                   </div>
                                   <div>
                                        Type
                                        <select value={data.type} name='type' onChange={onFormChange} style={{margin: "10px 95px"}}>   
                                             <option value="Evening">Evening</option>
                                             <option value="Day">Day</option>
                                             <option value="Morning">Morning</option>
                                             <option value="Bumper">Bumper</option>
                                        </select>
                                   </div> */}
                                   {/*  ======================= no need ==========================
                                   
                                   <div onChange={onFormChange}>
                                        Series
                                        <input type="text" name="time" value={data.time} style={{margin: "10px 90px", border: '1px solid black'}} />
                                   </div> -------------- */}
                                   {/* <div style={{color: Object.prototype.toString.call(data.resultDate) === '[object Date]' && !isNaN(data.resultDate) ? 'green' : "red" }}>
                                        {`*${data.resultDate}`} 
                                   </div>
                                   <button onClick={onAddWinnner} style={{color: "white", background: "blue", border: 'none', padding: "10px 20px", marginTop: "20px"}}>
                                        Save 
                                   </button> */}

                                   
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     );
}



export default NewLottery;